import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { BASE_PATH } from "router/pathName";

export type HelpLocationState = {
  from?: string;
  origin?: string;
};

const useHelpBackNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = useCallback(
    (event: Event) => {
      event.preventDefault();
      const state = location.state as HelpLocationState | null;
      const previousPath = state?.from;
      const originPath = state?.origin;

      if (originPath && location.pathname !== originPath) {
        navigate(originPath, {
          replace: true,
          ...(previousPath ? { state: { from: previousPath } } : {}),
        });
        return;
      }

      if (previousPath) {
        navigate(previousPath, { replace: true });
        return;
      }

      if (window.history.length > 1) {
        navigate(-1);
        return;
      }

      navigate(BASE_PATH, { replace: true });
    },
    [location.pathname, location.state, navigate]
  );

  useEffect(() => {
    document.addEventListener("back", handleBack);

    return () => {
      document.removeEventListener("back", handleBack);
    };
  }, [handleBack]);
};

export default useHelpBackNavigation;
